export default [
  {
    component: () => import("pages/mention_review/MentionReviewPage.vue"),
    meta: {
      accessLevel: "limited",
      title: "QC (Mention Review)",
    },
    name: "mention-review-index",
    path: "/mention_review",
    props: (route) => ({
      tab: route.query.tab,
      targetId: route.query.target_id,
      type: route.query.type,
    }),
  },
  {
    component: () => import("pages/mention_review/MentionReviewTriggers.vue"),
    meta: {
      title: "QC Triggers",
    },
    name: "qc-triggers-index",
    path: "/quality_control_triggers",
  },
  {
    component: () => import("pages/mention_review/PredictionModelsEdit.vue"),
    meta: {
      title: "Edit Prediction Models",
    },
    name: "qc-prediction-models-edit",
    path: "/quality-control-triggers/:id/predictors",
    props: true,
  },
];
